<customer-form [customer]="customerModel"></customer-form>